/* pp-formula: KaTeX auto-render for [data-pp-math] containers (formula block + physics_story).
   Delimiters: $$…$$ and \[…\] display, \(…\) inline. Raw LaTeX stays visible as the fallback if KaTeX fails to load.
   Fit: after render, any display equation wider than its container is scaled down (font-size on its .katex) to fit,
   floor 70% of the base size. Below the floor it keeps horizontal scroll + a right-edge fade (.pp-eq--scroll).
   Equations that already fit are never touched (no layout shift). No animation, so reduced motion is unaffected. */
(function () {
  var FLOOR = 0.7;

  function fitOne(d) {
    var k = d.querySelector(':scope > .katex');
    if (!k) return;
    if (!d.dataset.ppBase) {
      if (d.scrollWidth <= d.clientWidth) return; // fits at base size: leave it alone
      d.dataset.ppBase = parseFloat(getComputedStyle(k).fontSize);
    }
    var base = parseFloat(d.dataset.ppBase);
    k.style.fontSize = '';
    var cw = d.clientWidth, sw = d.scrollWidth;
    var scale = 1, scroll = false;
    if (cw > 0 && sw > cw) {
      scale = (cw - 2) / sw;
      if (scale < FLOOR) { scale = FLOOR; scroll = true; }
      k.style.fontSize = (base * scale).toFixed(2) + 'px';
      if (!scroll && d.scrollWidth > d.clientWidth) { // non-linear bits (borders, struts): refine once
        scale = Math.max(FLOOR, scale * (d.clientWidth - 2) / d.scrollWidth);
        k.style.fontSize = (base * scale).toFixed(2) + 'px';
        if (d.scrollWidth > d.clientWidth) scroll = true;
      }
    }
    d.dataset.ppScale = scale.toFixed(3);
    d.classList.toggle('pp-eq--scroll', scroll);
    if (scroll) {
      d.setAttribute('tabindex', '0'); // keyboard-scrollable region
      if (!d.dataset.ppScrollBound) {
        d.dataset.ppScrollBound = '1';
        d.addEventListener('scroll', function () { edge(d); }, { passive: true });
      }
      edge(d);
    } else {
      d.removeAttribute('tabindex');
      d.classList.remove('pp-eq--end');
    }
  }

  function edge(d) {
    d.classList.toggle('pp-eq--end', d.scrollLeft + d.clientWidth >= d.scrollWidth - 2);
  }

  function fitAll() {
    document.querySelectorAll('[data-pp-math] .katex-display').forEach(fitOne);
  }

  function run() {
    if (typeof window.renderMathInElement !== 'function') return;
    document.querySelectorAll('[data-pp-math]').forEach(function (el) {
      if (el.dataset.ppRendered) return;
      try {
        window.renderMathInElement(el, {
          delimiters: [
            { left: '$$', right: '$$', display: true },
            { left: '\\[', right: '\\]', display: true },
            { left: '\\(', right: '\\)', display: false }
          ],
          throwOnError: false,
          strict: 'ignore',
          trust: false
        });
        el.dataset.ppRendered = '1';
        el.classList.add('pp-formula--rendered');
      } catch (e) { /* keep fallback */ }
    });
    fitAll(); // same task as render: fitted size is the first one painted
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll); // KaTeX webfonts change widths
    window.addEventListener('load', fitAll);
    var t, w = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === w) return; // ignore height-only resizes (mobile URL bar)
      w = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(fitAll, 150);
    });
  }
  window.ppFormulaFit = fitAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
